module.exports = __webpack_public_path__ + "static/media/cancel-button.daebdd34.svg";